import { h, Component, Fragment } from 'preact'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Checkboxes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      collapsed: false
    }
  }

  handleDropdown(e) {
    const container = e.currentTarget.closest('.js-target-click')
    container.classList.toggle('activated')
  }

  handleOptions(e) {
    this.state.collapsed
      ? this.setState({ collapsed: false })
      : this.setState({ collapsed: true })
  }

  render() {
    return (
      <div className={`c-shop-filter__checkboxes`}>
        <div className="c-shop-filter__title js-target-trigger" onClick={this.handleDropdown.bind(this)}>
          {this.props.title}
        </div>

        <div className="c-shop-filter__options">
          {this.props.items.map((item, index) => {
            return (
              <div className="c-shop-filter__checkbox">
                <input
                  type="checkbox"
                  name={item}
                  value="1"
                  checked={this.props.currentElements.includes(item)}
                  id={item}
                  className="c-shop-filter__input"
                  onClick={this.props.handleChange}
                  data-target={this.props.target}
                  data-id={item}
                  disabled={this.props.isLoading}
                />
                <label className="c-shop-filter__label" for={item}>
                  {item}
                </label>
              </div>
            )
          })}

          <div className="c-shop-filter__view-results u-hide-on-medium-up">
            <div className="c-shop-filter__results-button" onClick={this.props.handleClose}>
              View results{' '}
              {this.props.allPosts.length
                ? `(${this.props.allPosts.length})`
                : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Checkboxes


// WEBPACK FOOTER //
// ./src/js/shop-overview/containers/Checkboxes.js